const getters = {
  getLegalUuids(state) {
    const genericUuids = state.info.legalDocuments.generic.map(item => item.uuid);
    const operatorUuids = state.info.legalDocuments.operator.map(item => item.uuid);
    return [...operatorUuids, ...genericUuids];
  },
};
export default getters;
